import { createRequire } from 'node:module';
const _require = createRequire(import.meta.url);
const _m = _require("@vue/compiler-sfc");
const _default = _m && _m.__esModule && 'default' in _m ? _m.default : _m;
export default _default;
export const extractIdentifiers = _m["extractIdentifiers"];
export const generateCodeFrame = _m["generateCodeFrame"];
export const isInDestructureAssignment = _m["isInDestructureAssignment"];
export const isStaticProperty = _m["isStaticProperty"];
export const walkIdentifiers = _m["walkIdentifiers"];
export const MagicString = _m["MagicString"];
export const babelParse = _m["babelParse"];
export const compileScript = _m["compileScript"];
export const compileStyle = _m["compileStyle"];
export const compileStyleAsync = _m["compileStyleAsync"];
export const compileTemplate = _m["compileTemplate"];
export const errorMessages = _m["errorMessages"];
export const extractRuntimeEmits = _m["extractRuntimeEmits"];
export const extractRuntimeProps = _m["extractRuntimeProps"];
export const inferRuntimeType = _m["inferRuntimeType"];
export const invalidateTypeCache = _m["invalidateTypeCache"];
export const parse = _m["parse"];
export const parseCache = _m["parseCache"];
export const registerTS = _m["registerTS"];
export const resolveTypeElements = _m["resolveTypeElements"];
export const rewriteDefault = _m["rewriteDefault"];
export const rewriteDefaultAST = _m["rewriteDefaultAST"];
export const shouldTransformRef = _m["shouldTransformRef"];
export const version = _m["version"];
export const walk = _m["walk"];